import {createAction} from 'redux-act';

export const GET_CUSTOMERS_COUNT = createAction(
  'analyticsCustomersCount/GET_CUSTOMERS_COUNT'
);
export const GET_CUSTOMERS_COUNT_SUCCESS = createAction(
  'analyticsCustomersCount/GET_CUSTOMERS_COUNT_SUCCESS'
);
